import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Index from "./page/index";
import Login from "./page/login";
import About from "./page/about";
import Product from "./page/product";
import DetailProduct from "./page/detail-product";
import Customer from "./page/customer";
import StandardsAndResearch from "./page/standards-and-research";
import Contact from "./page/contact";
import PolicyPrivacy from "./page/policy_privacy";

import AdminProduct from "./page/admin/product";
import AdminCustomer from "./page/admin/customer";
import AdminDemonstration from "./page/admin/demonstration";
import AdminSetting from "./page/admin/setting";
import AdminContact from "./page/admin/contact";

import Notfound from "./page/notfound";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Index />} />
    <Route path="/login" element={<Login />} />
    <Route path="/about" element={<About />} />
    <Route path="/product" element={<Product />} />
    <Route path="/detail-product" element={<DetailProduct />} />
    <Route path="/customer" element={<Customer />} />
    <Route path="/standards-and-research" element={<StandardsAndResearch />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/policy-privacy" element={<PolicyPrivacy />} />

    <Route path="/admin/product" element={<AdminProduct />} />
    <Route path="/admin/customer" element={<AdminCustomer />} />
    <Route path="/admin/demonstration" element={<AdminDemonstration />} />
    <Route path="/admin/setting" element={<AdminSetting />} />
    <Route path="/admin/contact" element={<AdminContact />} />

    <Route path="/*" element={<Notfound />} />
  </Routes>
);

export default AppRoutes;
